<template>
  <div
    class="valign-wrapper row"
    :style="h ? `height: ${this.h};` : 'height: auto;'"
  >
    <div class="col s6 offset-s3 center-align">
      <p v-if="message">
        {{ message }}
      </p>
      <p v-else>
        Chargement en cours...
      </p>
      <div class="progress progress grey darken-2">
        <div class="indeterminate orange accent-3" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
    props: {
        message: String,
        h: String
    }
}
</script>
